import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import {
  GetServiceForUploadDocument,
  GetServiceForUploadQuery,
  GetServiceForUploadQueryVariables,
} from './generated/referral-upload-jobs';

const useServiceForUpload = (serviceCode: string) => {
  const [{ data, fetching: pending }] = useSecureGraphqlQuery<
    GetServiceForUploadQuery,
    GetServiceForUploadQueryVariables
  >({ query: GetServiceForUploadDocument, variables: { serviceCode } });

  return { service: data?.getServiceForUpload, pending };
};

export { useServiceForUpload };
